import {
  Button,
  ButtonGroup,
  Card,
  Form,
  Table,
} from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import SearchInput from "../../../components/SearchInput";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../../routes";
import { fetchApi, postApi } from "../../../redux/api";
import { formatNumber } from "../../../redux/utils";

const STpvView = () => {
  const [filterText, setFilterText] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [loading, setLoading] = useState(false);
  const [pvList, setPvList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const mda = useSelector((state) => state.auth.user);
  const [openModal, setOpenModal] = useState(false);
  const [checkNo, setCheckNo] = useState("");
  const [pvNo, setPvNo] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [batchNo, setBatchNo] = useState(null);
  const [toggleModalData, setToggleModalData] = useState(false);
  const navigate = useNavigate();

  const closeModal = () => {
    setOpenModal(false);
  };

  const toggleModal = (item) => {
    setSelectedRow(item);
    setCheckNo(item?.check_no || "");
    setPvNo(item?.pv_code || "");
    setOpenModal(true);
  };

  const toggleBatchModal = () => {
    setToggleModalData(!toggleModalData);
  };

  const closeModal1 = () => {
    setToggleModalData(false);
  };

  useEffect(() => {
    if (mda?.mda_name && mda?.mda_code) {
      setLoading(true);
      fetchApi(
        `get_new_pv_by_mda?query_type=get_payment&mda_name=${mda.mda_name}&mda_code=${mda.mda_code}`
      )
        .then((data) => {
          setPvList(data.result || []);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [mda]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = pvList.map((item) => item.pv_code);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelection = (pv_code) => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(pv_code)
        ? prevSelectedRows.filter((rowId) => rowId !== pv_code)
        : [...prevSelectedRows, pv_code]
    );
  };

  const isSelected = (pv_code) => selectedRows.includes(pv_code);
  const newBatchNo = Math.floor(Math.random() * 10000);

  const handleGenerateSchedules = () => {
    if (selectedRows.length === 0) {
      alert("Please select at least one row to generate schedules.");
      return;
    }

    const selectedPvCodes = pvList
      .filter((item) => selectedRows.includes(item.pv_code))
      .map((item) => item.pv_code);

    setLoading(true);

    postApi("update_status/payment_schedule/by/pv_code", {
      status: "payment_schedule",
      pv_codes: selectedPvCodes,
      batch_reference: newBatchNo,
      query_type: "update_batch",
    })
      .then((response) => {
        console.log("Schedules generated successfully:", response);
        navigate(`${Routes.pv.paymentSchedule}/${pvList[0].pv_code}/${newBatchNo}`);
        toggleBatchModal();
        toggleModal();
        alert("Schedules generated successfully!");
        if (mda?.mda_name && mda?.mda_code) {
          setLoading(true);
          fetchApi(
            `get_new_pv_by_mda?query_type=get_payment&mda_name=${mda.mda_name}&mda_code=${mda.mda_code}`
          )
            .then((data) => {
              setPvList(data.result || []);
              toggleModal();
              setOpenModal(false);
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            })
            .finally(() => {
              setLoading(false);
            });
        }
      })
      .catch((error) => {
        console.error("Error generating schedules:", error);
        alert("Failed to generate schedules. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleGenerateCheck = () => {
    console.log("Submitting Check No:", checkNo, "PV No:", pvNo);

    postApi("generate_check", {
      check_no: checkNo,
      pv_no: pvList[0].pv_code,
      status: "Check_Generated",
    })
      .then((response) => {
          if (mda?.mda_name && mda?.mda_code) {
          setLoading(true);
          fetchApi(
            `get_new_pv_by_mda?query_type=get_payment&mda_name=${mda.mda_name}&mda_code=${mda.mda_code}`
          )
            .then((data) => {
              setPvList(data.result || []);
              toggleModal();
              setOpenModal(false);
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            })
            .finally(() => {
              setLoading(false);
            });
        }
        console.log("Check generated successfully:", response);
        alert("Check generated successfully!");
      })
      .catch((error) => {
        console.error("Error generating check:", error);
      })
      .finally(() => {
        closeModal();
      });
  };

  return (
    <div>
      {/* {JSON.stringify(pvList)} */}
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>Payment Schedule</h4>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <Button variant="outline-primary" size="sm">
              Share
            </Button>
            <Button variant="outline-primary" size="sm">
              Export
            </Button>
          </ButtonGroup>
        </div>
      </div>
      <Row>
        <Col
          md={6}
          style={{
            marginTop: 28,
          }}
        >
          <SearchInput
            placeholder="Search For Review Releases"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </Col>
        <Col md={6}>
          <Row
            style={{
              marginBottom: 10,
            }}
          >
            <Col md={6}>
              <Form.Group id="date_from">
                <Form.Label>Date From</Form.Label>
                <Form.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group id="date_to">
                <Form.Label>Date to</Form.Label>
                <Form.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Button
            variant="primary"
            className="me-2"
            onClick={handleGenerateSchedules}
            style={{
              marginTop: 10,
              marginBottom: 10,
              float: "right",
            }}
            // disabled={pvList.length > 0}
          >
            Generate Schedules
          </Button>
        </Col>
      </Row>
      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body
          className="p-0"
          style={{ height: "80vh", overflow: "scroll" }}
        >
          {loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <Table hover style={{ width: "100%" }} bordered>
              <thead
                className="table-header"
                style={{ backgroundColor: "green" }}
              >
                <tr>
                  <th style={{ backgroundColor: "#099019" }}>
                    <Form.Check
                      type="checkbox"
                      onChange={handleSelectAll}
                      checked={
                        pvList.filter(
                          (item) => item.approval_status !== "Check_release"
                        ).length > 0 &&
                        selectedRows.length ===
                          pvList.filter(
                            (item) => item.approval_status !== "Check_release"
                          ).length
                      }
                    />
                  </th>
                  {pvList.approval_status === "Check_release" ? (
                    <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                      Action
                    </th>
                  ) : (
                    ""
                  )}
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    PV Code
                  </th>
                  {/* <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Batch Number
                  </th> */}
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    MDA Name
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    MDA Code
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Economic Code
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Description
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Fund Code
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Fund Description
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Status
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "#fff" }}>
                    Amount Payable
                  </th>
                </tr>
              </thead>
              <tbody>
                {pvList.map((item) => (
                  <tr key={item.pv_code}>
                    <td>
                      {item.approval_status === "Check_release" ? (
                       <Button onClick={() => toggleModal(item)}>
                          Generate Check
                        </Button>
                      ) : (
                        <Form.Check
                          type="checkbox"
                          checked={isSelected(item.pv_code)}
                          onChange={() => handleRowSelection(item.pv_code)}
                        />
                      )}
                    </td>
                   
                    <td style={{ textAlign: "center" }}>{item.pv_code}</td>
                    {/* <td style={{ textAlign: "center" }}>
                      {item.batch_reference}
                    </td> */}
                    <td style={{ textAlign: "center" }}>{item.mda_name}</td>
                    <td style={{ textAlign: "center" }}>{item.mda_code}</td>
                    <td style={{ textAlign: "center" }}>
                      {item.economic_code}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item.description_code}
                    </td>
                    <td style={{ textAlign: "center" }}>{item.fund_code}</td>
                    <td style={{ textAlign: "center" }}>
                      {item.fund_description}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item.approval_status}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {formatNumber(item.amount)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      <Modal show={toggleModalData} size="md" onHide={closeModal1}>
        <Modal.Body className="text-center">
          Batch No: <b>{newBatchNo}</b>
        </Modal.Body>
      </Modal>

      <Modal show={openModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Generate Check</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mt-3">
            <Form.Label>Approval No</Form.Label>
            <Form.Control
              type="text"
              value={pvNo}
              onChange={(e) => setPvNo(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Check No</Form.Label>
            <Form.Control
              type="text"
              value={checkNo}
              onChange={(e) => setCheckNo(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleGenerateCheck}>
            Generate
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default STpvView;
